const DATE_OPERATORS = [
  {
    key: 'placeholder.today',
    label: 'placeholder.today'
  },
  {
    key: 'placeholder.yesterday',
    label: 'placeholder.yesterday'
  },
  {
    key: 'placeholder.this.week',
    label: 'placeholder.this.week'
  },
  {
    key: 'placeholder.last.week',
    label: 'placeholder.last.week'
  },
  {
    key: 'placeholder.last.month',
    label: 'placeholder.last.month'
  },
  {
    key: 'placeholder.last.30.days',
    label: 'placeholder.last.30.days'
  },
  {
    key: 'placeholder.this.month',
    label: 'placeholder.this.month'
  },
  {
    key: 'placeholder.last.quarter',
    label: 'placeholder.last.quarter'
  },
  {
    key: 'placeholder.this.quarter',
    label: 'placeholder.this.quarter'
  },
  {
    key: 'placeholder.last.six.months',
    label: 'placeholder.last.six.months'
  },
  {
    key: 'lastYear',
    label: 'placeholder.last.year'
  },
  {
    key: 'thisYear',
    label: 'placeholder.current.year'
  }
];

const YEAR_RANGE_OPERATORS = [
  {
    key: 'lastYear',
    label: 'placeholder.last.year'
  },
  {
    key: 'thisYear',
    label: 'placeholder.current.year'
  }
];
const MONTH_RANGE_OPERATORS = [
  {
    key: 'placeholder.last.month',
    label: 'placeholder.last.month'
  },
  {
    key: 'placeholder.last.three.months',
    label: 'placeholder.last.three.months'
  },
  {
    key: 'placeholder.last.six.months',
    label: 'placeholder.last.six.months'
  },
  {
    key: 'placeholder.last.twelve.months',
    label: 'placeholder.last.twelve.months'
  }
];

const LAST_THIRTY_DAYS = [
  {
    key: 'placeholder.today',
    label: 'placeholder.today'
  },
  {
    key: 'placeholder.yesterday',
    label: 'placeholder.yesterday'
  },
  {
    key: 'placeholder.this.week',
    label: 'placeholder.this.week'
  },
  {
    key: 'placeholder.last.week',
    label: 'placeholder.last.week'
  },
  {
    key: 'placeholder.last.30.days',
    label: 'placeholder.last.30.days'
  },
  {
    key: 'placeholder.this.month',
    label: 'placeholder.this.month'
  }
];

const MONTH = [
  {
    key: 'report.chart.groupBy.unit.january',
    value: 'January'
  },
  {
    key: 'report.chart.groupBy.unit.february',
    value: 'February'
  },
  {
    key: 'report.chart.groupBy.unit.march',
    value: 'March'
  },
  {
    key: 'report.chart.groupBy.unit.april',
    value: 'April'
  },
  {
    key: 'report.chart.groupBy.unit.may',
    value: 'May'
  },
  {
    key: 'report.chart.groupBy.unit.june',
    value: 'June'
  },
  {
    key: 'report.chart.groupBy.unit.july',
    value: 'July'
  },
  {
    key: 'report.chart.groupBy.unit.august',
    value: 'August'
  },
  {
    key: 'report.chart.groupBy.unit.september',
    value: 'September'
  },
  {
    key: 'report.chart.groupBy.unit.october',
    value: 'October'
  },
  {
    key: 'report.chart.groupBy.unit.november',
    value: 'November'
  },
  {
    key: 'report.chart.groupBy.unit.december',
    value: 'December'
  }
];

const NOTIFICATION_MESSAGE = {
  SCHEDULE: {
    SUCCESS: {
      METRIC: 'toast.dashboard.scheduled.success',
      PDF: 'toast.pdfreport.scheduled.success',
      DATA: 'toast.datareport.scheduled.success'
    },
    ERROR: {
      METRIC: 'toast.dashboard.scheduled.error',
      PDF: 'toast.pdfreport.scheduled.error',
      DATA: 'toast.datareport.scheduled.error'
    }
  },
  SHARE: {
    SUCCESS: {
      RETAINER: 'toast.dashboard.share.success',
      METRIC: 'toast.dashboard.share.success',
      PDF: 'toast.pdfreport.share.success',
      DATA: 'toast.datareport.share.success',
      INVOICE_STATEMENTS: 'toast.dashboard.share.success'
    },
    ERROR: {
      RETAINER: 'toast.dashboard.share.error',
      INVOICE_STATEMENTS: 'toast.dashboard.share.error',
      METRIC: 'toast.dashboard.share.error',
      PDF: 'toast.pdfreport.share.error',
      DATA: 'toast.datareport.share.error'
    }
  }
};

const DEFAULT_NOTIFICATION_TEMPLATE = {
  INVOICE_STATEMENTS: {
    name: '',
    content:
      '<p>Hi&nbsp;<span class="mention" data-index="3" data-denotation-char="#" data-value="Target user" data-id="attribute.report.targetUser">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Target user</span>﻿</span> ,</p><p><br></p><p>You have been shared a PDF export of <span class="mention" data-index="1" data-denotation-char="#" data-value="Dashboard name" data-id="attribute.report.name">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Dashboard name</span>﻿</span> . The PDF report is attached to this email.</p>',
    placeholdersUsed: JSON.stringify({
      content: {
        'attribute.report.targetUser': 'Target user',
        'attribute.report.link': 'Dashboard link',
        'attribute.report.name': 'Dashboard name'
      },
      subject: {
        'attribute.report.name': 'Dashboard name'
      }
    }),
    subject: 'Dashboard shared with you: #Dashboard name'
  },
  RETAINER: {
    name: '',
    content:
      '<p>Hi&nbsp;<span class="mention" data-index="3" data-denotation-char="#" data-value="Target user" data-id="attribute.report.targetUser"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Target user</span></span> ,</p><p><br></p><p>You have been given access to <span class="mention" data-index="1" data-denotation-char="#" data-value="Dashboard name" data-id="attribute.report.name"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Dashboard name</span></span> . Click on the below link to view it.</p><p><br></p><p><span class="mention" data-index="0" data-denotation-char="#" data-value="Dashboard link" data-id="attribute.report.link"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Dashboard link</span></span> </p>',
    placeholdersUsed: JSON.stringify({
      content: {
        'attribute.report.targetUser': 'Target user',
        'attribute.report.link': 'Dashboard link',
        'attribute.report.name': 'Dashboard name'
      },
      subject: {
        'attribute.report.name': 'Dashboard name'
      }
    }),
    subject: 'Dashboard shared with you: #Dashboard name'
  },
  METRIC: {
    name: '',
    content:
      '<p>Hi&nbsp;<span class="mention" data-index="3" data-denotation-char="#" data-value="Target user" data-id="attribute.report.targetUser"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Target user</span></span> ,</p><p><br></p><p>You have been given access to <span class="mention" data-index="1" data-denotation-char="#" data-value="Dashboard name" data-id="attribute.report.name"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Dashboard name</span></span> . Click on the below link to view it.</p><p><br></p><p><span class="mention" data-index="0" data-denotation-char="#" data-value="Dashboard link" data-id="attribute.report.link"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Dashboard link</span></span> </p>',
    placeholdersUsed: JSON.stringify({
      content: {
        'attribute.report.targetUser': 'Target user',
        'attribute.report.link': 'Dashboard link',
        'attribute.report.name': 'Dashboard name'
      },
      subject: {
        'attribute.report.name': 'Dashboard name'
      }
    }),
    subject: 'Dashboard shared with you: #Dashboard name'
  },
  PDF: {
    name: '',
    content:
      '<p>Hi&nbsp;<span class="mention" data-index="3" data-denotation-char="#" data-value="Target user" data-id="attribute.report.targetUser"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Target user</span></span> ,</p><p><br></p><p>You have been given access to <span class="mention" data-index="1" data-denotation-char="#" data-value="Report name" data-id="attribute.report.pdf.name"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Report name</span></span> . Click on the below link to view it.</p><p><br></p><p><span class="mention" data-index="0" data-denotation-char="#" data-value="Report link" data-id="attribute.report.pdf.link"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Report link</span></span> </p>',
    placeholdersUsed: JSON.stringify({
      content: {
        'attribute.report.targetUser': 'Target user',
        'attribute.report.pdf.link': 'Report link',
        'attribute.report.pdf.name': 'Report name'
      },
      subject: {
        'attribute.report.pdf.name': 'Report name'
      }
    }),
    subject: 'Report shared with you: #Report name'
  },
  DATA: {
    name: '',
    content:
      '<p>Hi&nbsp;<span class="mention" data-index="3" data-denotation-char="#" data-value="Target user" data-id="attribute.report.targetUser"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Target user</span></span> ,</p><p><br></p><p>You have been given access to <span class="mention" data-index="1" data-denotation-char="#" data-value="Report name" data-id="attribute.report.data.name"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Report name</span></span> . Click on the below link to view it.</p><p><br></p><p><span class="mention" data-index="0" data-denotation-char="#" data-value="Report link" data-id="attribute.report.data.link"><span contenteditable="false"><span class="ql-mention-denotation-char">#</span>Report link</span></span> </p>',
    placeholdersUsed: JSON.stringify({
      content: {
        'attribute.report.targetUser': 'Target user',
        'attribute.report.data.link': 'Report link',
        'attribute.report.data.name': 'Report name'
      },
      subject: {
        'attribute.report.data.name': 'Report name'
      }
    }),
    subject: 'Report shared with you: #Report name'
  }
};

const PDF_META_MAP = (isITProduct: boolean) => {
  return {
    autoGeneratedText: {
      title: 'reports.pdf.config.autoGeneratedText.title',
      description: 'reports.pdf.config.autoGeneratedText.description',
      logo: 'autoGeneratedTextConfig',
      imageHeader: 'reports.pdf.config.autoGeneratedText.logo.header'
    },
    clientLogo: {
      title: isITProduct
        ? 'itsm.reports.pdf.config.org.logo.title'
        : 'reports.pdf.config.client.logo.title',
      description: isITProduct
        ? 'itsm.reports.pdf.config.org.logo.description'
        : 'reports.pdf.config.client.logo.description',
      logo: 'clientLogoConfig',
      imageHeader: isITProduct
        ? 'itsm.reports.pdf.config.org.logo.header'
        : 'reports.pdf.config.client.logo.header'
    }
  };
};

const CHOICES_LABEL = {
  show: 'app.btn.show',
  hide: 'common.label.hide'
};

const GROWTH_CONFIG_CHOICES = [
  {
    name: 'APPROVED',
    choice: {
      title: 'invoiceViews.invoiceAudit.approvedItems.label',
      description:
        'msp.reports.profitablity.config.calculation.approved.description'
    }
  },
  {
    name: 'INVOICED',
    choice: {
      title: 'msp.reports.profitablity.config.calculation.invoiced.title',
      description:
        'msp.reports.profitablity.config.calculation.invoiced.description'
    }
  }
];

const TVMODE_INTERVAL = [
  {
    content: '1 Min',
    label: '1 Min',
    value: 1
  },
  {
    content: '10 Mins',
    label: '10 Mins',
    value: 10
  },
  {
    content: '20 Mins',
    label: '20 Mins',
    value: 20
  },
  {
    content: '30 Mins',
    label: '30 Mins',
    value: 30
  },
  {
    content: '40 Mins',
    label: '40 Mins',
    value: 40
  }
];

export {
  DATE_OPERATORS,
  LAST_THIRTY_DAYS,
  MONTH,
  NOTIFICATION_MESSAGE,
  DEFAULT_NOTIFICATION_TEMPLATE,
  MONTH_RANGE_OPERATORS,
  PDF_META_MAP,
  CHOICES_LABEL,
  TVMODE_INTERVAL,
  GROWTH_CONFIG_CHOICES,
  YEAR_RANGE_OPERATORS
};
